"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _classCallCheck = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLink = void 0;

var cssReset_1 = require("./lib/cssReset");

var WalletLinkProvider_1 = require("./provider/WalletLinkProvider");

var WalletLinkRelay_1 = require("./relay/WalletLinkRelay");

var util_1 = require("./util");

var WALLETLINK_URL = process.env.WALLETLINK_URL || "https://www.walletlink.org";
var WALLETLINK_VERSION = process.env.WALLETLINK_VERSION || require("../package.json").version || "unknown";

var WalletLink =
/*#__PURE__*/
function () {
  /**
   * Constructor
   * @param options WalletLink options object
   */
  function WalletLink(options) {
    _classCallCheck(this, WalletLink);

    this._appName = "";
    this._appLogoUrl = null;
    this._relay = new WalletLinkRelay_1.WalletLinkRelay({
      walletLinkUrl: options.walletLinkUrl || WALLETLINK_URL,
      version: WALLETLINK_VERSION,
      darkMode: !!options.darkMode
    });
    this.setAppInfo(options.appName, options.appLogoUrl);

    this._relay.attach(document.documentElement);

    cssReset_1.injectCssReset();
  }
  /**
   * Create a Web3 Provider object
   * @param jsonRpcUrl Ethereum JSON RPC URL
   * @param chainId Ethereum Chain ID (Default: 1)
   * @returns A Web3 Provider
   */


  _createClass(WalletLink, [{
    key: "makeWeb3Provider",
    value: function makeWeb3Provider(jsonRpcUrl) {
      var chainId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return new WalletLinkProvider_1.WalletLinkProvider({
        relay: this._relay,
        jsonRpcUrl: jsonRpcUrl,
        chainId: chainId
      });
    }
    /**
     * Set application information
     * @param appName Application name
     * @param appLogoUrl Application logo image URL
     */

  }, {
    key: "setAppInfo",
    value: function setAppInfo(appName, appLogoUrl) {
      this._appName = appName || "DApp";
      this._appLogoUrl = appLogoUrl || util_1.getFavicon();

      this._relay.setAppInfo(this._appName, this._appLogoUrl);
    }
    /**
     * Disconnect. After disconnecting, this will reload the web page to ensure
     * all potential stale state is cleared.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this._relay.resetAndReload();
    }
  }]);

  return WalletLink;
}();

exports.WalletLink = WalletLink;
/**
 * WalletLink version
 */

WalletLink.VERSION = WALLETLINK_VERSION;